



import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import CostRevenueChart from "../components/Charts/CostRevenueChart";
import JobPerformance from "../components/Charts/JobPerformance";
import { pageRoutes } from "../routes/PageRoutes";
import { useNavigate } from "react-router-dom";
import SubHeader from "../components/SubHeader";

const CustomerRequestDetail = () => {
      const navigate = useNavigate();
  const [isToggle, setIsToggle] = useState(false);

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="customer-requests" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div class="ct_px_23 ct_mt_30 pb-5">
 <div className="ct_mb_30">
              <SubHeader />
           
            </div>


            <div className="ct_white_bg_1">
<div className="d-flex align-items-center gap-3 justify-content-between flex-wrap ct_mb_14">
<div className="d-flex flex-wrap align-items-center gap-3">
   <div className="ct_text_dark ct_fs_20 ct_fw_600">
   Customer Request Details
 </div>



 <div className="d-flex align-items-center gap-2">
                     
                      <span class="active-dot"></span>
                    

                        <span class="ct_active_badge">
                         Quote Sent
                        </span>
                      </div>


{/* Rejected */}
<div class="d-none">
   <div className="d-flex align-items-center gap-2 ">
                     
                      <span class="inactive-dot"></span>
                    

                        <span class="ct_inactive_badge">
                         Rejected 
                        </span>
                      </div>
</div>


  {/* In Review */}
  <div class="d-none">

   <div className="d-flex align-items-center gap-2">
                     
                      <span class="pending-dot"></span>
                    

                        <span class="ct_pending_badge">
                         In Review 
                        </span>
                      </div>
  </div>



</div>

<div className="ct_text_dark">
  Date sent: 19 Jan 2026
</div>


</div>

              <div className="ct_bordeer_F2F4F7"></div>


                  <div class="ct_mt_30">
                         
                           <div class="ct_custom_badge " style={{backgroundColor: "rgb(203, 247, 255)" ,color: "rgb(35, 192, 232)"}}>
                          
                            <small class="ct_ff_ProximaNova_regular">Boat Captain</small>
                            </div>

                            <h5 className="ct_text_dark ct_fs_22 ct_fw_600 my-2">John Doe</h5>

                            <div className="ct_mb_16">
                            <span><svg className="me-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.96484 6.42833L7.78151 10.3067C8.58401 10.8408 8.98484 11.1083 9.41818 11.2125C9.80151 11.3042 10.2007 11.3042 10.5832 11.2125C11.0165 11.1083 11.4173 10.8408 12.2198 10.3067L18.0365 6.42833M5.96484 16.25H14.0365C15.4365 16.25 16.1365 16.25 16.6715 15.9775C17.1416 15.7377 17.5237 15.3553 17.7632 14.885C18.0365 14.35 18.0365 13.65 18.0365 12.25V7.75C18.0365 6.35 18.0365 5.65 17.764 5.115C17.5243 4.64462 17.1419 4.26218 16.6715 4.0225C16.1365 3.75 15.4365 3.75 14.0365 3.75H5.96484C4.56484 3.75 3.86484 3.75 3.32984 4.0225C2.85977 4.26232 2.47764 4.64474 2.23818 5.115C1.96484 5.65 1.96484 6.35 1.96484 7.75V12.25C1.96484 13.65 1.96484 14.35 2.23734 14.885C2.47702 15.3554 2.85946 15.7378 3.32984 15.9775C3.86484 16.25 4.56484 16.25 5.96484 16.25Z" stroke="#2F3849" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
Email:{" "}
</span>  
                             <span className="ct_text_dark ct_fs_16 ct_fw_600" >john.doe@example.com</span> 
                            </div>
                            <div>
                            <span>
                              <svg className="me-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.64299 6.57247C4.40487 5.00122 5.51362 3.58747 7.20737 3.06872C7.5081 2.97668 7.83262 3.00284 8.11473 3.14186C8.39684 3.28088 8.61528 3.52229 8.72549 3.81685L9.26862 5.26685C9.35594 5.50009 9.3716 5.7541 9.31358 5.99631C9.25556 6.23851 9.12652 6.45786 8.94299 6.62622L7.32737 8.1081C7.24754 8.18119 7.18806 8.27376 7.15475 8.37675C7.12145 8.47973 7.11546 8.5896 7.13737 8.6956L7.15174 8.7606L7.19174 8.92372C7.22737 9.06122 7.28112 9.25497 7.35674 9.48622C7.50674 9.9456 7.74612 10.5631 8.10237 11.18C8.45862 11.7968 8.87362 12.3131 9.19612 12.6725C9.36422 12.8595 9.53978 13.0396 9.72237 13.2125L9.77237 13.2587C9.85318 13.3303 9.95115 13.3797 10.0567 13.4022C10.1623 13.4246 10.2719 13.4193 10.3749 13.3868L12.4661 12.7287C12.7037 12.654 12.9582 12.652 13.197 12.723C13.4357 12.7939 13.6478 12.9345 13.8061 13.1268L14.7955 14.3281C15.208 14.8281 15.1592 15.5631 14.6849 16.005C13.3886 17.2131 11.6061 17.4612 10.3661 16.4637C8.84657 15.2375 7.56529 13.7424 6.58612 12.0531C5.59975 10.3643 4.94054 8.50542 4.64299 6.57247ZM8.44674 8.77747L9.78799 7.54747C10.155 7.21074 10.4131 6.77204 10.5292 6.28764C10.6452 5.80323 10.6139 5.29521 10.4392 4.82872L9.89549 3.37872C9.67366 2.7863 9.23425 2.30078 8.66683 2.02114C8.0994 1.74149 7.44669 1.68877 6.84174 1.87372C4.73862 2.5181 3.04987 4.40372 3.40737 6.75935C3.72828 8.84804 4.44009 10.8575 5.50549 12.6825C6.56162 14.5042 7.94352 16.1164 9.58237 17.4387C11.4417 18.9325 13.9255 18.4231 15.5374 16.92C15.9988 16.4903 16.2789 15.9006 16.3204 15.2714C16.3618 14.6422 16.1616 14.0209 15.7605 13.5343L14.7711 12.3331C14.4545 11.9484 14.0302 11.667 13.5525 11.5251C13.0749 11.3832 12.5658 11.3873 12.0905 11.5368L10.3549 12.0831C10.2772 12.0032 10.2011 11.9217 10.1267 11.8387C9.76992 11.4442 9.45432 11.0143 9.18487 10.5556C8.92225 10.0928 8.7076 9.60448 8.54424 9.0981C8.50955 8.99211 8.47704 8.88542 8.44674 8.7781" fill="#2F3849"/>
</svg>

Contact No.:{" "}
</span>  
                             <span className="ct_text_dark ct_fs_16 ct_fw_600" >+1 123-456-7890</span> 
                            </div>
                       </div>


                       <div class="ct_mt_30">
                      <div className="d-flex gap-4 flex-wrap">
                          <div>
                          <h6 class="mb-2 text-uppercase">BOAT</h6>
                          <div className="ct_info_clr_box">
                         Sea Voyager II
                          </div>
                        </div>

                          <div>
                          <h6 class="mb-2 text-uppercase">SERVICE TYPE</h6>
                          <div className="ct_info_clr_box">
Engine Repair                          </div>
                        </div>
                          <div>
                          <h6 class="mb-2 text-uppercase">Preferred Date</h6>
                          <div className="ct_info_clr_box">
                        Nov 15, 2023
                          </div>
                        </div>
                          <div>
                          <h6 class="mb-2 text-uppercase">LOCATION</h6>
                          <div className="ct_info_clr_box">
                       Harbor North, Slip 42
                          </div>
                        </div>
                      </div>
                       </div>

 <div class="ct_mt_30">

<h3 class="ct_fs_16 ct_fw_400 mb-2 text-uppercase">Description</h3>
                       <div className="edit-det-boat-det-box">
                        <p className="mb-0 ct_max_height_250 ct_custom_scroll pe-2">Looking to get the annual maintenance done before winter. Also noticed a small scratch on the port side hull that needs looking at during the wash. Please include winterization prep in the quote.</p>
                       </div>
 </div>


  <div class="ct_mt_30">

<h3 class="ct_fs_16 ct_fw_400 mb-2 text-uppercase">Attachments</h3>



 <div class="d-flex gap-5 flex-wrap">

   <div class="d-flex gap-2 align-items-center">
       <img
                              src="img/signupimgold.png"
                              class="ct_img_53 ct_border_radius_10"
                            />
                            <div>
                            <h3 class="ct_text_dark ct_fw_600 ct_fs_14 mb-1">hull_scratch.PNG</h3>
                            <p class="ct_text_para ct_fs_14 mb-0">19.6 MB</p>
                            </div>
   </div>

    <div class="d-flex gap-2 align-items-center">
       <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="53" height="53" rx="10" fill="#808C9D" fill-opacity="0.1"/>
<path d="M28.0312 16H20.4688C19.7094 16 19.0938 16.6157 19.0938 17.375V36.625C19.0938 37.3843 19.7094 38 20.4688 38H33.5312C34.2906 38 34.9062 37.3843 34.9062 36.625V22.8753L28.0312 16ZM33.5312 23.4449V23.5625H27.3438V17.375H27.462L33.5312 23.4449ZM20.4688 36.625V17.375H25.9688V24.9375H33.5312V36.625H20.4688Z" fill="black"/>
</svg>

                            <div>
                            <h3 class="ct_text_dark ct_fw_600 ct_fs_14 mb-1">hull_scratch.PDF</h3>
                            <p class="ct_text_para ct_fs_14 mb-0">28.6 MB</p>
                            </div>
   </div>

 </div>
                    
 </div>
            </div>


             <div className="ct_white_bg_1 ct_mt_40">
<div className="d-flex align-items-center gap-3 justify-content-between flex-wrap ct_mb_14">

   <div className="ct_text_dark ct_fs_20 ct_fw_600">
  Quote Details
 </div>






<div className="ct_text_dark">
  Date sent: 19 Jan 2026
</div>


</div>

              <div className="ct_bordeer_F2F4F7"></div>


<div class="row ct_mt_30">
  <div class="col-lg-8 mb-3">
          <div className="maintennce-service-wrapper d-grid gap-3">
                               
                                    <div className="service-row" >
                                      <div className="service-left">
                                        <div className="service-title ct_fs_16 ct_fw_700 ct_text_dark">
                                         Boat Washing
                                        </div>
                                        <p className="service-desc ct_fs_14 ct_fw_400 ct_text_para mb-0">
                                          Complete boat haul out and inspection
                                        </p>
                                      </div>
                                      <div className="service-right">
                                        <div className="price-block text-center">
                                          <div className="price-label ct_fs_12 ct_fw_700 ct_text_para mb-1">
                                            PRICE
                                          </div>
                                          <div className="price-value ct_fs_14 ct_fw_700">
                                            <span className="dollar ct_text_para">
                                              <i className="fa-solid fa-dollar-sign me-2"></i>
                                            </span>
                                           800
                                          </div>
                                        </div>
                                     
                                      </div>
                                    </div>
                                      <div className="service-row" >
                                      <div className="service-left">
                                        <div className="service-title ct_fs_16 ct_fw_700 ct_text_dark">
                                         Boat Washing
                                        </div>
                                        <p className="service-desc ct_fs_14 ct_fw_400 ct_text_para mb-0">
                                          Complete boat haul out and inspection
                                        </p>
                                      </div>
                                      <div className="service-right">
                                        <div className="price-block text-center">
                                          <div className="price-label ct_fs_12 ct_fw_700 ct_text_para mb-1">
                                            PRICE
                                          </div>
                                          <div className="price-value ct_fs_14 ct_fw_700">
                                            <span className="dollar ct_text_para">
                                              <i className="fa-solid fa-dollar-sign me-2"></i>
                                            </span>
                                           800
                                          </div>
                                        </div>
                                     
                                      </div>
                                    </div>
                                      <div className="service-row" >
                                      <div className="service-left">
                                        <div className="service-title ct_fs_16 ct_fw_700 ct_text_dark">
                                         Boat Washing
                                        </div>
                                        <p className="service-desc ct_fs_14 ct_fw_400 ct_text_para mb-0">
                                          Complete boat haul out and inspection
                                        </p>
                                      </div>
                                      <div className="service-right">
                                        <div className="price-block text-center">
                                          <div className="price-label ct_fs_12 ct_fw_700 ct_text_para mb-1">
                                            PRICE
                                          </div>
                                          <div className="price-value ct_fs_14 ct_fw_700">
                                            <span className="dollar ct_text_para">
                                              <i className="fa-solid fa-dollar-sign me-2"></i>
                                            </span>
                                           800
                                          </div>
                                        </div>
                                     
                                      </div>
                                    </div>
                               
                                
                              </div>
  </div>
   <div class="col-lg-4 mb-3">
<div class="ct_white_bg p-4 ct_border_radius_8 ct_box_shadow_0000001C">
  <div class="d-flex justify-content-between flex-wrap gap-3 align-items-center">
    <h6 class="ct_fs_16 ct_fw_700 ct_text_dark">TOTAL COST <span class="ct_fs_14 ct_fw_400 ct_text_dark fst-italic ct_text_para">Estimated</span></h6>

    <h6 class="ct_fs_16 ct_fw_700 ct_text_theme"> $1,695.60 </h6>
  </div>

  <div class="ct_mt_35">
    <div>
      <h5 class="ct_fs_14 ct_fw_600 ct_text_para mb-2 text-uppercase">Total Service cost</h5>
      <h6 class="ct_fs_16 ct_fw_600 ct_text_dark">$1275.40</h6>
    </div>
     <div className="ct_bordeer_F2F4F7 my-4"></div>
     <div>
      <h5 class="ct_fs_14 ct_fw_600 ct_text_para mb-2 text-uppercase"> Total Labour cost</h5>
      <h6 class="ct_fs_16 ct_fw_600 ct_text_dark">$1275.40</h6>
    </div>
      <div className="ct_bordeer_F2F4F7 my-4"></div>
     <div>
      <h5 class="ct_fs_14 ct_fw_600 ct_text_para mb-2 text-uppercase">Estimated duration</h5>
      <h6 class="ct_fs_16 ct_fw_600 ct_text_dark">4 Days</h6>
    </div>
  </div>
</div>
   </div>
</div>












                


                     

 <div class="ct_mt_30">

<h3 class="ct_fs_16 ct_fw_400 mb-2 text-uppercase">Terms:</h3>
                       <div className="edit-det-boat-det-box">
                       <ul class="ps-3">
<li className="ct_fs_16 ct_fw_400 ct_text_dark mb-1">Service cost includes labour only</li>
<li className="ct_fs_16 ct_fw_400 ct_text_dark mb-1">Parts will be charged separately</li>
<li className="ct_fs_16 ct_fw_400 ct_text_dark mb-0">Timeline may vary after inspection</li> 
                       </ul>
                       </div>
 </div>

  <div class="ct_mt_30">

<h3 class="ct_fs_16 ct_fw_400 mb-2 text-uppercase">Warranty:</h3>
                       <div className="edit-det-boat-det-box">
                       <ul class="ps-3">
<li className="ct_fs_16 ct_fw_400 ct_text_dark mb-1">7 days warranty on service</li>
<li className="ct_fs_16 ct_fw_400 ct_text_dark mb-1">Warranty applies only to listed services</li>
<li className="ct_fs_16 ct_fw_400 ct_text_dark mb-0">Does not cover misuse or external damage</li> 
                       </ul>
                       </div>
 </div>

  <div class="ct_mt_30">

<h3 class="ct_fs_16 ct_fw_400 mb-2 text-uppercase">Additional Notes:</h3>
                       <div className="edit-det-boat-det-box">
                     
<p className="ct_fs_16 ct_fw_400 ct_text_dark mb-1">This quote includes labour only. Additional parts or repairs identified during inspection will be communicated and charged separately. Timeline may vary depending on the condition of the boat.</p>

                      
                       </div>
 </div>


            </div>





{/* In Review button */}

<div class="">
  <div class="d-flex justify-content-end gap-3 mt-5">
  <button className=" ct_custom_block_btn ct_border_radius_12"  data-bs-toggle="modal"
                    data-bs-target="#ct_reject_request_modal">
    <svg class="me-2" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.2081 6.41667C15.5453 6.41667 16.8276 6.94784 17.7731 7.89334C18.7186 8.83883 19.2498 10.1212 19.2498 11.4583C19.2498 12.7955 18.7186 14.0778 17.7731 15.0233C16.8276 15.9688 15.5453 16.5 14.2081 16.5C12.871 16.5 11.5886 15.9688 10.6431 15.0233C9.69763 14.0778 9.16646 12.7955 9.16646 11.4583C9.16646 10.1212 9.69763 8.83883 10.6431 7.89334C11.5886 6.94784 12.871 6.41667 14.2081 6.41667ZM11.9385 9.18867C11.8525 9.27462 11.8043 9.39117 11.8043 9.51271C11.8043 9.63424 11.8525 9.7508 11.9385 9.83675L13.56 11.4592L11.9403 13.0781C11.8977 13.1206 11.8639 13.1712 11.8408 13.2268C11.8177 13.2824 11.8058 13.342 11.8057 13.4023C11.8057 13.4625 11.8175 13.5221 11.8405 13.5778C11.8635 13.6334 11.8973 13.684 11.9398 13.7266C11.9824 13.7692 12.0329 13.8031 12.0885 13.8261C12.1442 13.8492 12.2038 13.8611 12.264 13.8612C12.3242 13.8612 12.3839 13.8494 12.4395 13.8264C12.4952 13.8034 12.5458 13.7696 12.5884 13.7271L14.2081 12.1073L15.8306 13.7289C15.8729 13.7727 15.9235 13.8076 15.9794 13.8316C16.0353 13.8557 16.0955 13.8683 16.1563 13.8688C16.2172 13.8694 16.2775 13.8578 16.3339 13.8347C16.3902 13.8117 16.4414 13.7776 16.4844 13.7346C16.5274 13.6916 16.5615 13.6404 16.5845 13.5841C16.6075 13.5277 16.6191 13.4674 16.6186 13.4065C16.6181 13.3457 16.6054 13.2855 16.5814 13.2296C16.5574 13.1737 16.5225 13.1231 16.4787 13.0808L14.8571 11.4583L16.4805 9.83583C16.564 9.74939 16.6102 9.63362 16.6092 9.51344C16.6081 9.39327 16.5599 9.27831 16.475 9.19333C16.39 9.10835 16.275 9.06015 16.1549 9.05911C16.0347 9.05806 15.9189 9.10426 15.8325 9.18775L14.209 10.8102L12.5865 9.18775C12.5006 9.10183 12.384 9.05356 12.2625 9.05356C12.141 9.05356 12.0244 9.10183 11.9385 9.18775M8.26721 11H0.68729L0.59379 11.0064C0.421228 11.0302 0.264111 11.1185 0.154187 11.2536C0.0442627 11.3888 -0.0102727 11.5606 0.00159994 11.7344C0.0134726 11.9081 0.0908681 12.0709 0.218148 12.1899C0.345428 12.3088 0.513102 12.3749 0.68729 12.375H8.31946C8.24981 11.9201 8.23228 11.4588 8.26721 11ZM8.92079 8.70833H0.68729C0.513102 8.70828 0.345428 8.64211 0.218148 8.52319C0.0908681 8.40427 0.0134726 8.24148 0.00159994 8.06769C-0.0102727 7.89391 0.0442627 7.7221 0.154187 7.58698C0.264111 7.45185 0.421228 7.36349 0.59379 7.33975L0.68729 7.33333H9.90896C9.51579 7.74229 9.18304 8.2053 8.92079 8.70833ZM17.6456 3.66667H0.68729L0.59379 3.67308C0.421228 3.69683 0.264111 3.78519 0.154187 3.92031C0.0442627 4.05543 -0.0102727 4.22724 0.00159994 4.40103C0.0134726 4.57481 0.0908681 4.73761 0.218148 4.85652C0.345428 4.97544 0.513102 5.04161 0.68729 5.04167H17.6456L17.7391 5.03525C17.9117 5.01151 18.0688 4.92315 18.1787 4.78802C18.2887 4.6529 18.3432 4.48109 18.3313 4.30731C18.3194 4.13352 18.242 3.97073 18.1148 3.85181C17.9875 3.73289 17.8198 3.66672 17.6456 3.66667ZM17.6456 0H0.68729L0.59379 0.00641664C0.421228 0.0301596 0.264111 0.11852 0.154187 0.253643C0.0442627 0.388766 -0.0102727 0.560577 0.00159994 0.73436C0.0134726 0.908143 0.0908681 1.07094 0.218148 1.18986C0.345428 1.30878 0.513102 1.37495 0.68729 1.375H17.6456L17.7391 1.36858C17.9117 1.34484 18.0688 1.25648 18.1787 1.12136C18.2887 0.986234 18.3432 0.814423 18.3313 0.64064C18.3194 0.466857 18.242 0.304059 18.1148 0.185141C17.9875 0.066224 17.8198 5.3389e-05 17.6456 0Z" fill="white"/>
</svg>

    Reject </button>


      <div
        class="modal fade"
        id="ct_reject_request_modal"
        tabindex="-1"
        aria-labelledby="ct_reject_request_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-body">
              <div class="ct_delete_post_modal p-4">
                <figure>
                  <figcaption>
                    <div class="d-flex justify-content-between align-items-start">
                      <div class="">

                        <h4 class="ct_fs_24 ct_fw_600 ct_text_dark mb-2">
                          Reject Request?
                        </h4>
                        <p class="mb-0 ct_fs_16 ct_fw_400  ct_text_para" >
                        This request will be declined and cannot proceed further.
                        </p>
                      </div>

                      <div data-bs-dismiss="modal">
                        <i class="fa-solid fa-xmark"></i>
                      </div>
                    </div>
                  </figcaption>
                </figure>
                <div
                  class="d-flex justify-content-end border-0 gap-4 ct_modal_footer ct_mt_30"
                >
                  <button
                    type="button"
                    class="ct_orange_transparent_btn ct_h_40 "
                    data-bs-dismiss="modal"
                  >
                    Cancel</button
                  ><a
                    data-bs-dismiss="modal"
                    class="ct_border_radius_5 ct_h_40 ct_orange_btn  text-center ct_pointer"
                    href="javascript:void(0)"
                   
                  >Yes, Reject </a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>




    <a className=" ct_get_start_btn ct_pointer"  onClick={() => {
                            navigate(pageRoutes?.CreateQuote, {
                           
                            });
                            }}>
      <svg class="me-2" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.58501 11.0002L4.03134 6.01632C3.87276 4.58999 5.34126 3.54224 6.63834 4.15732L17.587 9.34382C18.9849 10.0057 18.9849 11.9948 17.587 12.6567L6.63834 17.8441C5.34126 18.4582 3.87276 17.4114 4.03134 15.9851L4.58501 11.0002ZM4.58501 11.0002H11.0017" stroke="white" stroke-width="1.375" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

      Send Quote </a>
</div>
</div>




       
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerRequestDetail;

